import { render, staticRenderFns } from "./EditSuggests.vue?vue&type=template&id=07961021&"
import script from "./EditSuggests.vue?vue&type=script&lang=js&"
export * from "./EditSuggests.vue?vue&type=script&lang=js&"
import style0 from "./EditSuggests.vue?vue&type=style&index=0&id=07961021&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports